module.exports = __webpack_public_path__ + "img/lookbook_7_center.78dac00b.png";